import { MINCOL } from "../../../constants/const";
import DropdownFilter from "../SD_einsehen/DropdownFilter";

export const bhfHeader = [
    {
        accessor: 'id',
        Header: 'id'
    },

    {
        accessor: 'bahnhof',
        Header: 'Name des Bahnhofs',
        width: '27em'
    },

    {
        accessor: 'kurz',
        Header: 'Abkürzung',
        width: MINCOL
    },

    {
        accessor: 'xkoord',
        Header: 'x-Koordinate',
        width: MINCOL
    },

    {
        accessor: 'ykoord',
        Header: 'y-Koordinate',
        width: MINCOL
    },

    {
        accessor: 'korr_typ',
        Header: 'Bahnhofstyp',
        Filter: DropdownFilter,
        width: MINCOL
    },

    {
        accessor: 'korr_kat',
        Header: 'Bahnhofskategorie',
        Filter: DropdownFilter,
        width: MINCOL
    },

    {
        accessor: 'korr_zv',
        Header: 'Zweckverband',
        Filter: DropdownFilter,
        width: MINCOL
    },

    {
        accessor: 'gueltig_von',
        Header: 'Gültigkeitsbeginn',
        width: MINCOL
    },

    {
        accessor: 'gueltig_bis',
        Header: 'Gültigkeitsende',
        width: MINCOL
    },

    {
        accessor: 'id_typ',
        Header: 'id_typ'
    },

    {
        accessor: 'id_kat',
        Header: 'id_kat'
    },

    {
        accessor: 'id_zv',
        Header: 'id_zv'
    },

    {
        accessor: 'kommentar',
        Header: 'Kommentar'
    }
]

export const listInputs = ['bahnhof', 'kurz', 'xkoord', 'ykoord', 'gueltig_von', 'kommentar', 'gueltig_bis'];
export const listDropdowns = [
    {
        accessor: 'korr_typ',
        Header: "Bahnhofstyp"
    },
    {
        accessor: 'korr_kat',
        Header: "Bahnhofskategorie"
    },
    {
        accessor: 'korr_zv',
        Header: "zugehöriger Zweckverband"
    }];

export const csvHeaderBhf = [
    'Bahnhof',
    'Abkürzung',
    'x-Koordinate',
    'y-Koordinate',
    'Bahnhofstyp',
    'Bahnhofskategorie',
    'Zweckverband',
    'Gültigkeitsbeginn',
    'Gültigkeitsende',
    'Kommentar'
];